<script lang="ts">
import { defineComponent } from 'vue';
import RadioButton from '../../components/RadioButton.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import router from '../../router';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: 'SurveyQ1',
  components: {
    RadioButton,
    Button: SolutoButton
  },
  data () {
    return {
      data: [
        { text: this.$t('survey_01_rate10'), key: '10' },
        { text: '9', key: '9' },
        { text: '8', key: '8' },
        { text: '7', key: '7' },
        { text: '6', key: '6' },
        { text: '5', key: '5' },
        { text: '4', key: '4' },
        { text: '3', key: '3' },
        { text: '2', key: '2' },
        { text: '1', key: '1' },
        { text: this.$t('survey_01_rate0'), key: '0' }
      ]
    };
  },
  computed: {
    ...mapGetters([
      'recommendationScale',
      'isCallSurvey'
    ])
  },
  methods: {
    ...mapActions([
      'changeRecommendationScale'
    ]),
    change (event: number) {
      this.changeRecommendationScale(event);
    },
    nextScreen () {
      router.push({ path: '/survey/question2/' });
    },
    goBack () {
      window.parent.postMessage(
        { solutoSurvey: 'goBackToPermission' }, '*'
      );
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q1-body">
      <p class="with-top-margin caution">{{ $t('survey_01_01') }}</p>
      <p class="caution">{{ $t('survey_01_02') }}</p>
      <p class="with-margin">{{ isCallSurvey ? $t('survey_01_03_call') : $t('survey_01_03') }}</p>
      <p class="with-margin">{{ isCallSurvey ? $t('survey_01_04_call') : $t('survey_01_04') }}</p>
      <p class="with-margin">{{ isCallSurvey ? $t('survey_01_05_call') : $t('survey_01_05') }}</p>
      <radio-button :text="data" @change="change($event)" :value="recommendationScale.toString()"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :disabled="recommendationScale === 999"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
